export const localize = (text, params)=>text.replace(/\{\{([^}]+)\}\}/g, (_match, param)=>params?.[param] ?? '');

//# sourceMappingURL=localize.js.map